SERIES_TAB_VALUE